import ordersIcon from 'app/assets/icons/sidebar/orders.svg';
import pharmaciesIcon from 'app/assets/icons/sidebar/pharmacies.svg';
import { authRoles } from '../../../auth';

import {
  broadcastsItem,
  calendarItem,
  masterServicesItem,
  patientsItem,
  servicesItem,
  smsCampaignsItem,
  superLinksItem,
  userManagementItem,
  websiteBuilderItem,
} from './sharedNavigationItems';

// The UK's grouped sidebar without its UK-only pages: no plans in Canada, so no Plus+ tags
// (`plusFeature`) or Upgrades. Item ids are what useToggleCanadaOrdersView and usePharmacyStats
// address, and group ids key the remembered open/closed state, so keep them stable.
const canadaNavigationConfig = [
  {
    id: 'workflow',
    title: 'Workflow',
    type: 'group',
    children: [
      patientsItem,
      {
        id: 'requests-component',
        title: 'Requests',
        translate: 'REQUESTS',
        type: 'item',
        img: ordersIcon,
        url: `requests`,
        display: false,
      },
      {
        id: 'orders-component',
        title: 'Orders',
        translate: 'ORDERS',
        type: 'item',
        img: ordersIcon,
        url: `orders`,
        display: false,
      },
    ],
  },
  {
    id: 'marketing-station',
    title: 'Grow & automate',
    type: 'group',
    featured: true,
    auth: authRoles.pharmacist,
    children: [
      { ...websiteBuilderItem, auth: authRoles.pharmacist },
      {
        // No Patient invites icon in the Figma set yet.
        id: 'mti-uploader',
        title: 'Patient invites',
        type: 'item',
        icon: 'cloud_upload',
        url: 'mti-uploader',
        auth: authRoles.pharmacist,
      },
      // Canada keeps the plural name on purpose.
      { ...broadcastsItem, title: 'Broadcasts', auth: authRoles.pharmacist },
      { ...superLinksItem, auth: authRoles.pharmacist },
      { ...smsCampaignsItem, auth: authRoles.support },
    ],
  },
  {
    id: 'appointment-booking',
    title: 'Services',
    type: 'group',
    children: [
      { ...calendarItem, auth: authRoles.pharmacist },
      { ...servicesItem, auth: authRoles.pharmacist },
    ],
  },
  {
    id: 'admin',
    title: 'Admin',
    type: 'group',
    children: [
      {
        id: 'pharmacy-page',
        title: 'Pharmacy details',
        type: 'item',
        img: pharmaciesIcon,
        url: `pharmacies`,
      },
      { ...userManagementItem, auth: authRoles.pharmacyAdmin },
    ],
  },
  {
    id: 'support',
    title: 'Staff',
    type: 'group',
    auth: authRoles.support,
    children: [
      { ...masterServicesItem, auth: authRoles.support },
      {
        // No Support dashboard icon in the Figma set yet.
        id: 'support-dashboard',
        title: 'Support dashboard',
        type: 'item',
        icon: 'support_agent',
        url: 'support-dashboard',
        auth: authRoles.support,
      },
    ],
  },
];

export default canadaNavigationConfig;
